import { render, staticRenderFns } from "./jd-input-intnum.vue?vue&type=template&id=5213dc16&"
import script from "./jd-input-intnum.vue?vue&type=script&lang=js&"
export * from "./jd-input-intnum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports